/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationData } from './PaginationData';
import {
    PaginationDataFromJSON,
    PaginationDataFromJSONTyped,
    PaginationDataToJSON,
    PaginationDataToJSONTyped,
} from './PaginationData';
import type { ProjectDataWithPermissions } from './ProjectDataWithPermissions';
import {
    ProjectDataWithPermissionsFromJSON,
    ProjectDataWithPermissionsFromJSONTyped,
    ProjectDataWithPermissionsToJSON,
    ProjectDataWithPermissionsToJSONTyped,
} from './ProjectDataWithPermissions';

/**
 * 
 * @export
 * @interface UserProjects200Response
 */
export interface UserProjects200Response {
    /**
     * 
     * @type {PaginationData}
     * @memberof UserProjects200Response
     */
    pagination?: PaginationData;
    /**
     * 
     * @type {Array<ProjectDataWithPermissions>}
     * @memberof UserProjects200Response
     */
    data?: Array<ProjectDataWithPermissions>;
}

/**
 * Check if a given object implements the UserProjects200Response interface.
 */
export function instanceOfUserProjects200Response(value: object): value is UserProjects200Response {
    return true;
}

export function UserProjects200ResponseFromJSON(json: any): UserProjects200Response {
    return UserProjects200ResponseFromJSONTyped(json, false);
}

export function UserProjects200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProjects200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': json['pagination'] == null ? undefined : PaginationDataFromJSON(json['pagination']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ProjectDataWithPermissionsFromJSON)),
    };
}

export function UserProjects200ResponseToJSON(json: any): UserProjects200Response {
    return UserProjects200ResponseToJSONTyped(json, false);
}

export function UserProjects200ResponseToJSONTyped(value?: UserProjects200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDataToJSON(value['pagination']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ProjectDataWithPermissionsToJSON)),
    };
}

